'use strict';

import angular from 'angular';

/**
 * FavorisController - contrôleur de la page des favoris
 */
export default angular.module('observatoireApp')
  .controller('FavorisController', ['$scope', '$http', '$timeout', '$state', '$sce', 'Auth', 'FavorisService', 'PublicationsService', 'TextesOfficielsService', 'VideothequeService', function($scope, $http, $timeout, $state, $sce, Auth, FavorisService, PublicationsService, TextesOfficielsService, VideothequeService) {
      
      // Vérification de l'authentification
      $scope.favoris = [];
      $scope.videosFavorites = [];
      $scope.filtres = { texte: '' };
      $scope.utilisateurConnecte = false;
      $scope.utilisateur = null;
      $scope.chargement = true;
      $scope.chargementVideos = false;
      $scope.videoEnVisualisation = null;

      // Charger l'identité puis les favoris
      Auth.identity().then(function(user) {
        if (user) {
          $scope.utilisateurConnecte = true;
          $scope.utilisateur = user;
          $scope.favoris = FavorisService.getFavoris();
          $scope.chargementVideos = true;
          VideothequeService.getVideosFavorites().then(function(videos) {
            $scope.videosFavorites = videos;
            $scope.chargementVideos = false;
          }).catch(function() {
            $scope.chargementVideos = false;
          });
        }
        $scope.chargement = false;
      }).catch(function() {
        $scope.chargement = false;
      });

      // Filtrer les favoris par type
      $scope.filtreParType = function(type) {
        return function(favori) {
          if (type === 'dataset') {
            return !favori.itemType || favori.itemType === 'dataset';
          }
          return favori.itemType === type;
        };
      };

      // Compter les favoris par type (pour ng-if de section)
      $scope.nbParType = function(type) {
        return $scope.favoris.filter($scope.filtreParType(type)).length;
      };

      // Extrait l'ID numérique depuis 'pub_5' ou 'to_3'
      function extractNumericId(favoriId) {
        var parts = (favoriId || '').split('_');
        return parseInt(parts[parts.length - 1]);
      }

      // Ouvre le modal avec une fileUrl
      function ouvrirModal(favori, fileUrl, fileType) {
        $scope.favoriEnVisualisation = angular.extend({}, favori, {
          fileUrl: fileUrl,
          fileType: fileType || 'PDF'
        });
        $scope.trustedDocUrl = fileUrl ? $sce.trustAsResourceUrl(fileUrl) : null;
        $scope.chargementDoc = false;
        var el = document.getElementById('favoriViewerModal');
        if (el) bootstrap.Modal.getOrCreateInstance(el).show();
      }

      // Déclenche un téléchargement
      function declencherTelechargement(fileUrl, titre, fileType) {
        var link = document.createElement('a');
        link.href = fileUrl;
        link.download = (titre || 'document') + '.' + (fileType || 'pdf').toLowerCase();
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      // Récupère le document depuis l'API puis exécute l'action
      function fetchEtAction(favori, action) {
        var numId = extractNumericId(favori.id);
        $scope.chargementDoc = true;

        if (favori.itemType === 'publication') {
          PublicationsService.getPublicationById(numId)
            .then(function(pub) {
              var url = pub.fileUrl || pub.pdfUrl || null;
              action(url, pub.fileType || favori.fileType || 'PDF');
            })
            .catch(function() { $scope.chargementDoc = false; });
        } else if (favori.itemType === 'texte-officiel') {
          TextesOfficielsService.getTexteOfficielById(numId)
            .then(function(texte) {
              var url = texte.fileUrl || texte.pdfUrl || null;
              action(url, texte.fileType || favori.fileType || 'PDF');
            })
            .catch(function() { $scope.chargementDoc = false; });
        }
      }

      // Visualiser un document depuis les favoris
      $scope.visualiserDocument = function(favori) {
        if (favori.fileUrl) {
          ouvrirModal(favori, favori.fileUrl, favori.fileType);
          return;
        }
        fetchEtAction(favori, function(url, type) {
          ouvrirModal(favori, url, type);
        });
      };

      $scope.fermerVisualiseur = function() {
        var el = document.getElementById('favoriViewerModal');
        if (el) { var m = bootstrap.Modal.getInstance(el); if (m) m.hide(); }
        $scope.favoriEnVisualisation = null;
        $scope.trustedDocUrl = null;
      };

      // Télécharger un document depuis les favoris
      $scope.telechargerDocument = function(favori) {
        if (favori.fileUrl) {
          declencherTelechargement(favori.fileUrl, favori.titre, favori.fileType);
          return;
        }
        fetchEtAction(favori, function(url, type) {
          if (url) {
            declencherTelechargement(url, favori.titre, type);
          }
        });
      };

      // Regarder une vidéo favorite
      $scope.regarderVideo = function(video) {
        $scope.videoEnVisualisation = angular.extend({}, video, {
          urlSecurisee: $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + video.videoId)
        });
        var el = document.getElementById('favoriVideoModal');
        if (el) bootstrap.Modal.getOrCreateInstance(el).show();
      };

      $scope.fermerVideo = function() {
        var el = document.getElementById('favoriVideoModal');
        if (el) { var m = bootstrap.Modal.getInstance(el); if (m) m.hide(); }
        $scope.videoEnVisualisation = null;
      };

      // Retirer une vidéo des favoris
      $scope.retirerVideoFavori = function(videoId) {
        if (confirm('Voulez-vous vraiment retirer cette vidéo de vos favoris ?')) {
          VideothequeService.toggleFavori(videoId);
          $scope.videosFavorites = $scope.videosFavorites.filter(function(v) {
            return v.videoId !== videoId;
          });
        }
      };

      // Fonction pour supprimer un favori
      $scope.supprimerFavori = function(favoriId) {
        if (confirm('Voulez-vous vraiment retirer ce jeu de données de vos favoris ?')) {
          if (FavorisService.removeFavori(favoriId)) {
            // Recharger la liste des favoris
            $scope.favoris = FavorisService.getFavoris();
          }
        }
      };
      
      // Fonction pour exporter un favori
      $scope.exporterFavori = function(favori, format) {
        // Simuler un chargement des données
        var type = favori.type;
        var annee = favori.annee;
        
        // Récupérer les données (simulation)
        $http.get('api/data/' + type + '/' + annee).then(
          function(response) {
            var data = response.data;
            
            if (format === 'excel') {
              exporterExcel(data, favori.libelle + ' - ' + annee, type);
            } else if (format === 'pdf') {
              exporterPDF(data, favori.libelle + ' - ' + annee);
            }
          },
          function(error) {
            // En cas d'erreur, utiliser des données fictives
            var data = generateMockData(type, annee);
            
            if (format === 'excel') {
              exporterExcel(data, favori.libelle + ' - ' + annee, type);
            } else if (format === 'pdf') {
              exporterPDF(data, favori.libelle + ' - ' + annee);
            }
          }
        );
      };
      
      // Fonction pour ouvrir la connexion (version sans modal pour le moment)
      $scope.ouvrirModalConnexion = function() {
        alert('Pour utiliser cette fonctionnalité, veuillez vous connecter.');
        // Simuler une connexion réussie pour la démonstration
        $timeout(function() {
          // Simuler un utilisateur connecté
          Auth.setCurrentUser({ id: 1, username: 'demo_user', email: 'demo@example.com' });
          $scope.utilisateurConnecte = true;
          $scope.favoris = FavorisService.getFavoris();
        }, 500);
      };
      
      // Fonction pour générer des données fictives pour la démonstration
      function generateMockData(type, annee) {
        var libelles = [];
        var data = [];
        
        if (type === 'tableau-des-operations-financieres-de-letat') {
          libelles = ['Recettes fiscales', 'Recettes non fiscales', 'Dons', 'Transferts', 'Autres recettes'];
        } else if (type === 'depenses') {
          libelles = ['Personnel', 'Biens et services', 'Transferts', 'Subventions', 'Investissements'];
        } else if (type === 'financement') {
          libelles = ['Emprunts intérieurs', 'Emprunts extérieurs', 'Dons', 'Émissions obligataires', 'Autres financements'];
        }
        
        var montantTotal = 1000000000;
        var montantRestant = montantTotal;
        
        for (var i = 0; i < libelles.length; i++) {
          var pourcentage;
          var montant;
          
          if (i === libelles.length - 1) {
            montant = montantRestant;
            pourcentage = (montant / montantTotal) * 100;
          } else {
            pourcentage = Math.round(Math.random() * 20) + 5;
            montant = Math.round((pourcentage / 100) * montantTotal);
            montantRestant -= montant;
          }
          
          data.push({
            libelle: libelles[i],
            montant: montant,
            pourcentage: parseFloat(pourcentage.toFixed(1))
          });
        }
        
        return data;
      }
      
      // Fonction pour exporter en Excel
      function exporterExcel(data, titre, typeDonnees) {
        // Créer un workbook
        var wb = XLSX.utils.book_new();
        wb.Props = {
          Title: titre,
          Subject: "Observatoire du Tchad - " + typeDonnees,
          Author: "Observatoire du Tchad",
          CreatedDate: new Date()
        };
        
        // Préparer les données pour la feuille de calcul
        var wsData = [];
        
        // En-tête
        wsData.push(["Libellé", "Montant (FCFA)", "Pourcentage (%)"]);
        
        // Ajouter les données
        data.forEach(function(item) {
          var ligne = [
            item.libelle,
            item.montant,
            item.pourcentage + '%'
          ];
          wsData.push(ligne);
        });
        
        // Créer une worksheet
        var ws = XLSX.utils.aoa_to_sheet(wsData);
        
        // Définir des largeurs de colonnes plus raisonnables
        var wscols = [
          { wch: 30 }, // Libellé
          { wch: 15 }, // Montant
          { wch: 15 }  // Pourcentage
        ];
        ws['!cols'] = wscols;
        
        // Ajouter la worksheet au workbook
        XLSX.utils.book_append_sheet(wb, ws, "Données");
        
        // Télécharger le fichier
        XLSX.writeFile(wb, titre + '.xlsx');
      }
      
      // Fonction pour exporter en PDF
      function exporterPDF(data, titre) {
        // Créer un nouveau document PDF
        var doc = new jsPDF();
        
        // Ajouter un titre
        doc.setFontSize(16);
        doc.text(titre, 14, 22);
        
        // Ajouter la date d'exportation
        doc.setFontSize(10);
        doc.text('Exporté le ' + new Date().toLocaleDateString(), 14, 30);
        
        // Créer le tableau
        var colonnes = [
          { header: 'Libellé', dataKey: 'libelle' },
          { header: 'Montant (FCFA)', dataKey: 'montant' },
          { header: 'Pourcentage (%)', dataKey: 'pourcentage' }
        ];
        
        var lignes = [];
        data.forEach(function(item) {
          lignes.push({
            libelle: item.libelle,
            montant: item.montant.toLocaleString(),
            pourcentage: item.pourcentage + '%'
          });
        });
        
        // Générer le tableau
        doc.autoTable({
          head: [colonnes.map(col => col.header)],
          body: lignes.map(row => colonnes.map(col => row[col.dataKey])),
          startY: 40,
          styles: { fontSize: 10 },
          columnStyles: {
            0: { cellWidth: 70 },
            1: { cellWidth: 60, halign: 'right' },
            2: { cellWidth: 40, halign: 'right' }
          },
          headStyles: { fillColor: [63, 81, 181] }
        });
        
        // Télécharger le PDF
        doc.save(titre + '.pdf');
      }
    }]);
